<div class="w-full pb-1 mb-1">
   <div class="bg-cdra-blue-light-100 rounded flex py-1 me-1">
      <label class="text-xs ps-2 inline-flex w-full self-center" [attr.for]="'form_' + feature.key"> {{ feature.key }}</label>
      @if(feature.type === 'boolean') {
         <input
            [attr.id]="'form_' + feature.key "
            type="checkbox"
            class="t-sidenav-feature-checkbox text-xs border border-gray-400 me-2"
            (change)="feature.change(feature.value)"
            [(ngModel)]="feature.value"
         />
      }
      @if(feature.type === 'string') {
         <input
            [attr.id]="'form_' + feature.key "
            type="text"
            class="t-sidenav-feature-input text-xs border border-gray-400 min-w-10 me-2"
            (change)="feature.change(feature.value)"
            [(ngModel)]="feature.value"

         />
      }
      @if(feature.type === 'integer' || feature.type === 'double') {
         <input
            [attr.id]="'form_' + feature.key "
            type="number"
            [attr.step]="determineStep(feature.type)"
            class="t-sidenav-feature-input text-xs border border-gray-400 min-w-10 me-2"
            (change)="feature.change(feature.value)"
            [(ngModel)]="feature.value"

         />
      }
      @if(feature.type === 'enum') {
         <select
            [attr.id]="'form_' + feature.key "
            class="t-sidenav-feature-select text-xs border border-gray-200 max-w-24 w-fit me-2"
            (change)="feature.change(feature.value)"
            [(ngModel)]="feature.value"
         >
            @for(option of feature.valueOptions; track option) {
               <option [value]="option">{{ option }}</option>
            }
         </select>
      }
   </div>
   <p class="text-xs italic text-center">{{ feature.description }}</p>
</div>